import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';

export const hasAuthCookie = () => {
  return !!Cookies.get('cw_d_session_info');
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    // If the account id is not found, redirect to the first account
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

const capitalize = str =>
  str
    .split(/[._-]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getCredentialsFromEmail = email => {
  const [localPart, domain] = email.split('@');
  const namePart = localPart.split('+')[0];
  return {
    fullName: capitalize(namePart),
    accountName: capitalize(domain.split('.')[0]),
  };
};

// TelyChat fork patch (2026-09-15): honor ?r= post-login redirect so portal
// SSO links land directly on a Chatwoot page (e.g. the WhatsApp/Twilio inbox
// wizard). Strictly validated — only same-origin /app/accounts/<id>/ paths are
// accepted; anything else falls through to the default dashboard behavior.
const FORK_REDIRECT_RE = /^\/app\/accounts\/\d+(?:[/?#][\w\-./=&%~:]*)?$/;
const getForkPostLoginRedirect = () => {
  try {
    const r = new URLSearchParams(window.location.search).get('r');
    return r && FORK_REDIRECT_RE.test(r) ? r : null;
  } catch (e) {
    return null;
  }
};

export const getLoginRedirectURL = ({
  ssoAccountId,
  ssoConversationId,
  user,
}) => {
  const forkRedirect = getForkPostLoginRedirect();
  if (forkRedirect) return forkRedirect;
  const accountPath = getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    if (ssoConversationId) {
      return frontendURL(`${accountPath}/conversations/${ssoConversationId}`);
    }
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};
